import * as yup from 'yup';

import { BrainReminder } from '@/shared/types/brain';
import { reminderFormSchema } from '@/util/validation/schemas/action-schemas';

export interface NodeOption {
  dialog_name: string;
  dialog_id?: string;
  value: string;
  label: string;
  node_type: string;
}

export interface FormReminder extends Pick<BrainReminder, 'reminder_id'> {
  reminder_seconds: number | null;
  node: NodeOption | null;
}

export const isEmptyReminder = (reminder: FormReminder) =>
  !reminder.reminder_seconds && !reminder.node;

export interface PreferencesForm {
  // '' means no starting dialog
  starting_node_id: string;
  reminders: FormReminder[];
}

export const preferencesFormSchema = reminderFormSchema.shape({ starting_node_id: yup.string() });
